import { z } from "zod";

export const RunStepSchema = z.object({
  id: z.string().uuid(),
  workflow_run_id: z.string().trim(),
  node_id: z.string().trim(),
  node_type: z.string().trim(),
  status: z.enum(["PENDING", "SUCCESS", "FAILED", "SKIPPED", "SUSPENDED"]),
  started_at: z.string().datetime(),
  completed_at: z.string().datetime().optional(),
  duration_ms: z.number().int().optional(),
  error_message: z.string().optional(),
  input_r2_key: z.string().optional(),
  output_r2_key: z.string().optional(),
  meta_json: z.string().optional(),
});

export type RunStep = z.infer<typeof RunStepSchema>;
